import { airportParser, locationParser } from 'helpers';

const findAirport = (code, airports, destinations) => {
  let airport;
  if (code && airports) airport = airportParser(airports, code);
  if (!airport && destinations) airport = locationParser(destinations, code);

  return airport;
};

export default findAirport;
